import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthenticationServicesService } from './../../api-module/services/authentication/authentication-services.service';
import { Component, OnInit, ChangeDetectorRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Subscription } from "rxjs";
import { LookupService } from '../../api-module/services/lookup-services/lookup.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationModalComponent } from '../shared/notification-modal/notification-modal.component';
import { SharedNotificationService } from '../shared/shared-notification.service';
import { delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { MenuItemLink, MenuItems } from '../shared/main-menu';
import { AuthPermissionsService } from '../../services/auth-permissions-service';
import { NotificationsService } from 'src/app/dispatcher/notifications.service';
import { SharedService } from '../shared/shared.service';
import { DatePipe } from '@angular/common';
import { StaticConfigurationsEnum } from "src/app/models/configurations-models/configurations.enums";
import { AuthConfigurationService } from 'src/app/services/auth-configuration-service';
import { bashost } from 'src/app/api-module/services/globalPath';

@Component({
  selector: 'app-main-header-component',
  templateUrl: './main-header-component.component.html',
  styleUrls: ['./main-header-component.component.css'],
})

export class MainHeaderComponentComponent implements OnInit, AfterViewInit, AfterViewChecked {
  isLoggedin: boolean = false;
  isInvoicePage: boolean = false;
  isUserLogged: boolean = false;
  isloading: boolean = false;
  toggleNotification: boolean;
  newNotificationToggle: boolean;
  notificationBackgroundClass: any[];
  CurentUser: any = {};
  toggelingNotificationIconInterval: any;
  quotationSubscription: Subscription;
  callSubscription: Subscription;
  orderSubscription: Subscription;
  RoleSubscription: Subscription;
  notifications: any[] = [];
  toggelingNotificationIconClass: string[] = [];
  userId = "";
  role: any = "";
  quotationConfigurations: StaticConfigurationsEnum;
  finishLoggingOut: boolean;
  items: MenuItem[];
  menu: MenuItemLink[];
  showMenu: boolean;
  showFixMeLogo: boolean = false;
  showTeamReportAndIssueMaterialToTeam: boolean = false;
  showContractRevenueAllocationReport: boolean = false;
  hideGuestOrder: boolean = false;
  showTrackingLinks: boolean = false;
  subscription: Subscription;
  company: any = {};
  bashostUrl: string = '';
  isSuccessOrFailUpaymentUrl: boolean = false;
  hideInventoryTransactionReport: boolean = false;
  constructor(

    public sharedNotificationService: SharedNotificationService,
    private lookupService: LookupService,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    public authenticationService: AuthenticationServicesService,
    private router: Router,
    private modalService: NgbModal,
    public translateService: TranslateService,
    private authPermissionsService: AuthPermissionsService,
    private sharedService: SharedService,
    public menuItems: MenuItems,
    private datePipe: DatePipe,
    private notificationsService: NotificationsService,
    private configuration: AuthConfigurationService,
    private activatedRoute: ActivatedRoute

  ) {
  }

  ngOnInit() {
    const currentURL = window.location.href;
    if (currentURL.includes('upayment?') && currentURL.includes('&Result') && currentURL.includes('TrackID')) {
      this.isSuccessOrFailUpaymentUrl = true;
    }
    else { this.isSuccessOrFailUpaymentUrl = false; }
    this.bashostUrl = bashost;
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.showFixMeLogo = params.fixme;
        console.log(this.showFixMeLogo);
      });
      debugger
    this.configuration.IsConfigEnabled(StaticConfigurationsEnum.DisplaySales)
      .subscribe(res => {
        debugger
        this.showMenu = res;

        this.configuration.IsConfigEnabled(StaticConfigurationsEnum.EnableSTSOracleIntegration)
          .subscribe(res => {
            this.showTeamReportAndIssueMaterialToTeam = res;

            this.configuration.IsConfigEnabled(StaticConfigurationsEnum.EnableContractRevenueAllocationReport)
              .subscribe(res => {

                this.showContractRevenueAllocationReport = res;

                this.configuration.IsConfigEnabled(StaticConfigurationsEnum.HideGuestOrder)
                  .subscribe(res => {

                    this.hideGuestOrder = res;

                    this.configuration.IsConfigEnabled(StaticConfigurationsEnum.HasTrackingOption)
                      .subscribe(res => {
                        this.showTrackingLinks = res;


                        this.configuration.IsConfigEnabled(StaticConfigurationsEnum.HideInventoryTransactionReport)
                          .subscribe(res => {
                            this.hideInventoryTransactionReport = res;



                          });

                      });
                  });
              });
          });
      });





    this.activateCurrentGroup();
    this.getNotifications();

    this.authenticationService.loadNotification.subscribe(res => {
      this.getNotifications();
    });
    this.authenticationService.isLoggedin.subscribe(loggedIn => {
      this.isLoggedin = loggedIn;
      this.menuItems.menu.forEach(item => {
        if (item.name == 'Sales') { item.display = this.showMenu; }
      });
      this.menu = this.menuItems.menu;
    });
    this.getConfigurations();
    console.log(' this.menu', this.menu)

    this.authenticationService.isInvoicePage.subscribe(value => {
      this.isInvoicePage = value;
    });

    this.isloading = true;
    this.sharedNotificationService.notificationCountSubject
      .subscribe(
        (count) => {
          this.isloading = false;
          this.sharedNotificationService.notificationCount = count;
          this.lookupService.GetNotificationCenterCountByRecieverId(this.userId)
            .subscribe(
              (response) => {
                if (response && response.isSucceeded) {
                  if (response.data.data) {
                    response.data.data.map(element => {
                      // element.createdDate= this.datePipe.transform( this.sharedService.convertFromUtc(new Date(element. createdDate) ),"MM/dd/yyyy hh:mm a" );
                      element.createdDate = this.datePipe.transform(this.sharedService.convertFromUtc(new Date(element.createdDate)), "MM/dd/yyyy hh:mm a");
                      element.body = element.body;
                      //   .split(" at ")[0] +" at  " +
                      //   this.datePipe.transform(this.sharedService.getUtcDate(element. createdDate), "MM/dd/yyyy hh:mm a");
                    });
                  }
                  this.sharedNotificationService.notificationCount = response.data;
                  this.getNotifications();
                }
              }
            );
        }, err => {
          this.isloading = false;
        }
      );

    this.CurentUser = JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
    this.notificationBackgroundClass = ['hide-notification-transparent-background'];
    this.quotationSubscription = this.authenticationService.quotaionSignalR.subscribe((quotation) => {
      quotation.type = 'quotation';
      this.notifications.push(quotation);
      this.newNotificationToggle = true;
      this.toggelingNotificationIcon();
    });

    this.callSubscription = this.authenticationService.callSignalR.subscribe((call) => {
      call.type = 'call';
      this.notifications.push(call);
      this.newNotificationToggle = true;
      this.toggelingNotificationIcon();
    });

    this.RoleSubscription = this.authenticationService.userRoles.pipe(delay(0)).subscribe((role) => {
      this.role = role[0];
      if (this.role === "Admin") {
        this.sharedNotificationService.notificationCount = 0;
      }
    });

    this.orderSubscription = this.authenticationService.orderSignalR.subscribe((order) => {
      this.notifications.push(order);
      this.newNotificationToggle = true;
      this.toggelingNotificationIcon();
    });

    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        this.authenticationService.CurrentUser();
      }
    });
    this.getCurrentClientCompany();
  }

  goTotrackingLink() {
    if (this.showTrackingLinks) {
      window.open('https://gps.fleetrite.io/index.php', '_blank');
    }

  }
  getConfigurations() {
    // Set Configuraions to menu Items
    this.isloading = true;
    this.configuration.AllConfigurationsUpdated.subscribe(
      (res: any) => {
        this.isloading = false;
        if (res &&  res.data) {
          localStorage.setItem('QuotationConfiguration', JSON.stringify(res.data));
          let configurationList = res.data;
          if (configurationList) {
            this.menu.forEach((x: any) => {
              // if(x.name == "Sales" || x.name == "ContractsManagement"  || x.name == "Inventory")
              if (x.childrens) {
                x.childrens.forEach(y => {
                  if (y.route == '/admin/team-management/orders-material-report' || y.route == '/admin/issue-materials') {
                    y.display = !this.showTeamReportAndIssueMaterialToTeam;
                  }
                  if (y.route == '/contracts/contract-revenue-allocation-report') {

                    y.display = this.showContractRevenueAllocationReport;
                  }
                  if (y.route == '/customer/GuestOrderLanding') {

                    y.display = !this.hideGuestOrder && y.display;
                  }
                  if (y.route == '/admin/materials/inventory-transactions') {

                    y.display = this.hideInventoryTransactionReport && y.display;
                  }
                  configurationList.forEach(cfg => {
                    if (y.configKey == cfg.id) {
                      y.config = cfg.value;
                    }
                  });

                  if (y.childrens) {
                    y.childrens.forEach(z => {
                      configurationList.forEach(cfg => {
                        if (z.configKey == cfg.id) {
                          z.config = cfg.value;
                        }
                      });
                    });
                  }

                });
              }
            });
          }
        }
      });

  }
  onServerFailed(err) {
    this.isloading = false;
    this.messageService.add({
      severity: 'error',
      summary: this.translateService.instant('error'),
      detail: this.translateService.instant('Failed due to server error!')
    });
  }

  profile() {
    this.router.navigate(['profile']);
  }

  getNotifications() {
    this.notifications = [];
    let AlghanimCurrentUser = localStorage.getItem("AlghanimCurrentUser");
    if (AlghanimCurrentUser) {
      this.userId = JSON.parse(AlghanimCurrentUser).data.userId;
    }
    if (this.userId) {
      this.isloading = true;
      this.lookupService.GetNotificationCenterCountByRecieverId(this.userId).subscribe((response) => {
        if (response && response.isSucceeded) {
          this.sharedNotificationService.notificationCount = response.data;
          let notificationObj = {
            recieverId: this.userId,
            isRead: false,
            pageInfo: {
              pageNo: 1,
              pageSize: 5
            }
          };
          this.isloading = true;
          this.lookupService.postNotificationCenter(notificationObj)
            .subscribe(
              (response) => {
                if (response.data.data != undefined) {
                  response.data.data.map(element => {
                    element.createdDate = this.datePipe.transform(this.sharedService.convertFromUtc(new Date(element.createdDate)), "MM/dd/yyyy hh:mm a");
                    element.body = element.body
                  });
                }
                this.notifications = response.data.data;
                this.isloading = false;
              }, err => this.onServerFailed(err)
            );
        } else {
          this.onServerFailed(response)
        }
      }, err => this.onServerFailed(err));
    }
  }


  uponApprovalAction(obj, index, accept) {
    this.lookupService.ChangeActionFlagNotificationCenterItem(obj.id)
      .subscribe(
        (ChangeActionFlagNotificationCenterItemResponse) => {
          this.notifications[index].isActionTaken = true;
          if (ChangeActionFlagNotificationCenterItemResponse && ChangeActionFlagNotificationCenterItemResponse.isSucceeded) {
            if (accept) {
              this.sharedNotificationService.acceptChangeRankSubject.next(obj);
            }
            this.sharedNotificationService.notificationCountSubject
              .next((this.sharedNotificationService.notificationCount - 1));
          } else {
            this.onServerFailed(ChangeActionFlagNotificationCenterItemResponse);
          }
        },
        err => {
          this.onServerFailed(err);
        }
      );
  }

  onApproveRequest(e, notification: any, index: number, acceptChangeValue: boolean) {
    this.isloading = true;
    e.stopPropagation();
    var accept = acceptChangeValue;
    this.notifications[index].className = "wait";
    // let orders = JSON.parse(notification.data);
    this.lookupService.putNotificationCenterChangeTeamOrderRank(acceptChangeValue, notification.id)
      .subscribe(
        (response) => {
          this.isloading = false;
          if (response && response.isSucceeded) {
            let obj = Object.assign({}, notification);
            obj.isRead = true;
            this.uponApprovalAction(obj, index, accept);
          } else {
            if (response && response.status && response.status.code && !response.isSucceeded && response.status.code == 6) {
              console.error(response);
              this.notifications[index].isActionTaken = true;
              this.notifications[index].isRead = true;
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('error'),
                detail: this.translateService.instant('Unable to change rank! Please ask the technnician to resend the request.')
              });
              let obj = notification;
              this.uponApprovalAction(obj, index, accept);
            } else {
              this.onServerFailed(response);
            }
          }
        }, err => this.onServerFailed(err)
      );
  }

  onNotificationClick(notificationData, index: number) {
    this.isloading = true;
    let obj = notificationData;
    obj.isRead = true;
    // this.lookupService.updateNotificationCenterItem(obj)
    this.lookupService.ChangeReadFlagNotificationCenterItem(obj.id)
      .subscribe(
        (response) => {
          if (response && response.isSucceeded) {
            this.sharedNotificationService.notificationCountSubject
              .next((this.sharedNotificationService.notificationCount));
            let modalRef = this.modalService.open(NotificationModalComponent);
            modalRef.componentInstance.data = notificationData;
            this.sharedNotificationService.notificationCount--;
            this.notifications.splice(index, 1);
            this.getNotifications();
            this.isloading = false;
            modalRef.result
              .then(
                () => {
                  this.toggleNotificationPopup();
                }
              );
          }
        }, err => {
          this.isloading = false;
        }
      );
  }

  onMarkAllAsRead() {
    this.isloading = true;
    this.notifications = [];
    let AlghanimCurrentUser = localStorage.getItem("AlghanimCurrentUser");
    if (AlghanimCurrentUser) {
      this.userId = JSON.parse(AlghanimCurrentUser).data.userId;
    }
    this.lookupService.MarkAllAsReadByRecieverIdURL(this.userId)
      .subscribe(
        (response) => {
          if (response && response.isSucceeded) {
            this.notifications = [];
            this.sharedNotificationService.notificationCount = 0;
            this.sharedNotificationService.notificationCountSubject.next(0);
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('Successful!'),
              detail: this.translateService.instant(`All marked as read`)
            });
          }
          this.isloading = false;
        }, err => {
          this.isloading = false;
        }
      );
  }

  LogoutAll() {
    if (!this.finishLoggingOut) {
      let userId = JSON.parse(localStorage.getItem("AlghanimCurrentUser")).data.userId;
      let deviceId = localStorage.getItem("deviceId")
      let obj = {
        userId: userId,
        deviceId: deviceId
      };
      this.finishLoggingOut = true;
      this.lookupService.logout(obj).subscribe((res: any) => {
        this.notifications = [];
        this.newNotificationToggle = false;
        localStorage.removeItem("deviceId");
        localStorage.removeItem("AlghanimCurrentUserId");
        this.toggelingNotificationIconClass = ['show-notification-icon'];
        this.stopIntervalNotificationIconToggeling();
        this.router.navigate(['/login']);
        this.finishLoggingOut = false;
        this.isLoggedin = false;
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('Failed'),
          detail: this.translateService.instant(`Failed to load data due to server error.`)
        });
        this.notifications = [];
        this.newNotificationToggle = false;
        localStorage.removeItem("deviceId");
        localStorage.removeItem("AlghanimCurrentUserId");
        this.toggelingNotificationIconClass = ['show-notification-icon'];
        this.stopIntervalNotificationIconToggeling();
        this.router.navigate(['/login']);
        this.finishLoggingOut = false;
      }
      );
    }
  }

  toggleNotificationBody() {
    this.toggleNotification = !this.toggleNotification;
    this.newNotificationToggle = false;
    this.toggelingNotificationIconClass = ['show-notification-icon'];
    this.stopIntervalNotificationIconToggeling();
    if (this.notificationBackgroundClass.toString() == ['show-notification-transparent-background'].toString()) {
      this.notificationBackgroundClass = ['hide-notification-transparent-background'];
    } else {
      this.notificationBackgroundClass = ['show-notification-transparent-background'];
    }
    if (this.CurentUser.data.roles.indexOf("Supervisor") > -1)
      this.router.navigate(['supervisor/notifications']);
    else if (this.role === "Engineer") {
      this.router.navigate(['supervisor/notifications']);
    }

    else if (this.role === "ContractAdministrator") {
      this.router.navigate(['supervisor/notifications']);
    }
    else if (this.role === "Call Center") {
      this.router.navigate(['customer/notifications']);
    }
    else if (this.role === "Supervisor CallCenter") {
      this.router.navigate(['customer/notifications']);
    }
    else if (this.role === "Admin") {
      this.router.navigate(['customer/notifications']);
    }
    else
      this.router.navigate(['dispatcher/notifications']);
  }

  toggelingNotificationIcon() {
    this.toggelingNotificationIconInterval = setInterval(
      () => {
        if (this.newNotificationToggle) {
          if (this.toggelingNotificationIconClass.toString() == ['show-notification-icon'].toString()) {
            this.toggelingNotificationIconClass = ['hide-notification-icon'];
          } else {
            this.toggelingNotificationIconClass = ['show-notification-icon'];
          }
        } else {
          this.toggelingNotificationIconClass = ['show-notification-icon'];
        }
      }
      , 1000)
  }

  stopIntervalNotificationIconToggeling() {
    clearInterval(this.toggelingNotificationIconInterval);
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges()
  }

  isRoleExist(role: string, roles: string[]): boolean {
    if (roles.length == 0) {
      return false;
    }
    return roles.some(roleToFind => roleToFind == role);
  }

  activateCurrentGroup() {
    this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        const cuurentUrl = event.urlAfterRedirects;
        if (this.menu) {
          this.menu.forEach(route => route.isAcive = false)
          for (let index = 0; index < this.menu.length; index++) {
            const element = this.menu[index];
            if (!element.childrens || element.childrens.length == 0) {
              if (element.route && cuurentUrl.includes(element.route)) {
                element.isAcive = true;
                return;
              }
              continue;
            }
            for (let j = 0; j < element.childrens.length; j++) {
              const child = element.childrens[j];
              if (child.route && cuurentUrl.includes(child.route)) {
                if (child.route === cuurentUrl) {
                  element.isAcive = true;
                  return;
                }

              }
            }
          }
        }

      }
    });
  }

  toggleNotificationPopup() {
    this.toggleNotification = !this.toggleNotification;
    this.newNotificationToggle = false;
    this.toggelingNotificationIconClass = ['show-notification-icon'];
    this.stopIntervalNotificationIconToggeling();
    if (this.notificationBackgroundClass.toString() == ['show-notification-transparent-background'].toString()) {
      this.notificationBackgroundClass = ['hide-notification-transparent-background'];
    } else {
      this.notificationBackgroundClass = ['show-notification-transparent-background'];
    }
  }

  /**
   * allowed or not
   *
   *
   * @param permission
   * @param notAdmin
   * @returns
   */
  hasPermission(permission: number | number[], notAdmin?: boolean): boolean {
    return this.authPermissionsService.userHasPermissionTo(permission, notAdmin);
  }
  getCurrentClientCompany() {
    this.subscription = this.lookupService.getCompanyProfileSettings().subscribe(res => {

      this.company = res.data;

    });
  }
}
